import React from 'react';
import { usePermissions } from '../../helpers/permissions';
export default function PermissionChecker(props) {
    var permissions = usePermissions();
    var x = props;
    if (x.if && permissions.allowsAction(x.if)) {
        return props.children;
    }
    if (x.not && !permissions.allowsAction(x.not)) {
        return props.children;
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=PermissionChecker.js.map